import React from 'react';
import {AiFillCopyrightCircle} from 'react-icons/ai'

export default function Footer(){
    return (
        <div className="footer-container">
            <p className="footer-copyright"><AiFillCopyrightCircle />Yosri Swidan</p>
            <p className="footer-intisials">Y.S</p>
        </div>
    )
}